
import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from '../ui/avatar';
import { User } from 'lucide-react';

type AuthorProps = {
  name: string;
  avatar?: string;
};

const BlogAuthor: React.FC<AuthorProps> = ({ name, avatar }) => {
  // Determine which avatar to use
  const getAvatarImage = () => {
    // Check if it's both Darin and Lucas
    if (name.includes('&') || name.includes('and')) {
      return "/lovable-uploads/1972d93f-9ded-476a-8ebe-a3bae9daa6d1.png";
    }
    
    // If it's Darin only
    if (name.toLowerCase().includes('darin')) {
      return "/lovable-uploads/dfc24d1a-b270-420d-8318-7135be5f9906.png"; // Darin's profile picture
    }
    
    // If it's Lucas only
    if (name.toLowerCase().includes('lucas')) {
      return "/lovable-uploads/5df08f40-9826-454a-8f1d-7c027a288f9d.png"; // Lucas's profile picture
    }
    
    // Default to the provided avatar or null
    return avatar || null;
  };
  
  const avatarImage = getAvatarImage();
  
  return (
    <div className="flex items-center">
      <Avatar className="h-8 w-8 mr-2 border border-gray-200">
        {avatarImage ? (
          <AvatarImage src={avatarImage} alt={name} className="object-cover" />
        ) : (
          <AvatarFallback>
            <User size={16} />
          </AvatarFallback>
        )}
      </Avatar>
      <span className="font-medium">{name}</span>
    </div>
  );
};

export default BlogAuthor;
